import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 596822BD-8373-402C-9D27-C341405F55F9
 * name bookmark-plus
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bookmark-plus.svg
 * tags
 */
export const BookmarkPlusIcon = createSvgIcon(<><path d="M17,3A2,2 0 0,1 19,5V21L12,18L5,21V5C5,3.89 5.9,3 7,3H17M11,7V9H9V11H11V13H13V11H15V9H13V7H11Z" /></>, 'BookmarkPlusIcon');
export default BookmarkPlusIcon